export enum Tenant {
  CZ = 'Czechia',
  FI = 'Finland'
}